<template>
  <div class="app-container">
    <el-form :model="form" status-icon ref="form" label-width="100px" class="demo-ruleForm">
      <el-form-item label="输入二级密码：" label-width="170px" prop="pass">
        <el-input type="password" v-model="form.secondaryPassword" autocomplete="off" ref="secondaryPassword"></el-input>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import "splitpanes/dist/splitpanes.css"
import user from "@/views/system/user/index.vue";
import cookies from "js-cookie";
import {ifSecondary} from "@/utils/userInfo";

export default {
  name: "secondary_password",
  components: {},
  data() {
    return {
      // 表单参数
      form: {
        secondaryPassword: ''
      },
    };
  },
  created() {
    this.form.secondaryPassword = ''
    // 组件挂载后自动聚焦到输入框
    // this.$refs.secondaryPassword.focus()
  },
  methods: {
    submitForm() {
      if (this.form.secondaryPassword === '' || this.form.secondaryPassword === null || this.form.secondaryPassword === undefined) {
        this.$message.error('请输入二级密码！');
      } else {
        let userInfo = this.$store.state.userInfo
        ifSecondary(this.form.secondaryPassword, userInfo.id).then(res => {
          if (res.code === 200) {
            this.$emit("submit-success", {message: "验证成功"});
            this.form.secondaryPassword= '';
          } else {
            this.$emit("submit-error", {message: res.msg});
            this.form.secondaryPassword= '';
          }
        })
      }
    },
  },
  mounted(){
    // 组件挂载后自动聚焦到输入框
    this.$refs.secondaryPassword.focus()
  }
};
</script>

<style scoped>
</style>